import React from "react";
import { connect } from "react-redux";
import { actions } from '../../store/reducers/authentication';
import AuthLayout from "../../components/Layout/AuthLayout";
import { useTranslation } from "react-i18next";
import Button from '../../components/Button';
import useQuery from "../../helpers/useQuery";
import { useParams } from "react-router-dom";

const mstp = ({ authentication }) => ({ authentication });
const step = 1;

const RegisterConfirm = ({ logout }) => {
  const { t } = useTranslation();
  const query = useQuery();
  const { app } = useParams();
  const mode = query.get('type');

  return <AuthLayout
    app={app}
    step={step}
    title="Thank you!"
    subTitle={(
      <>
        {mode === 'notVerified' ? (
          <>
            {t('An email confirmation link is on its way.')}
            <br />
            <br />
            {t('confirmText')}
          </>
        ) : (
          <>
            {t('confirmText2')}
          </>
        )}
        <br />
        <br />
        <Button
          className="normal-br"
          onClick={() => {
            logout(() => {
              setTimeout(() => {
                window.location.href = '/';
              }, 200);
            });
          }}
          type="primary">
          {t("Go Back")}
        </Button>
      </>
    )}
  />
};

export default connect(mstp, actions)(RegisterConfirm);

